/**
 * Получить номер карты
 * @param user
 */
export function cardDataNumber(user: any) {
  return user?.physicalUserCard?.cardNumber;
}
